import React, {useContext, useEffect, useState} from "react";
import { useNavigate } from "react-router";
import $ from "jquery";
import LoaderCircle from "../tools/loader/LoaderCircle";
import FormBuilderV2 from "../../class/tool/FormBuilderV2";
import CompanyController from "../../stories/_client/Companies/CompanyController";
import StoreController from "../../stories/_client/Stores/StoreController";
import LegalDataController from "../../stories/_client/LegalDatas/LegalDataController";
import ContactController from "../../stories/_client/Contacts/ContactController";
import AddressController from "../../stories/_client/Addresses/AddressController";
import Store from "../../stories/_client/Stores/Store";
import LegalData from "../../stories/_client/LegalDatas/LegalData";
import Address from "../../stories/_client/Addresses/Address";
import Contact from "../../stories/_client/Contacts/Contact";
import TagController from "../../stories/_client/Tags/TagController";
import LicenseController from "../../stories/_setup/Licenses/LicenseController";
import AccountController from "../../stories/_setup/Accounts/AccountController";
import Account from "../../stories/_setup/Accounts/Account";
import ContractController from "../../stories/_client/Contract/ContractController";
import Contract from "../../stories/_client/Contract/Contract";
import StringTools from "../../class/tool/StringTools";
import AppContext from "../../context/AppContext";
import "../../css/form/FormV2.css";
import License from "../../stories/_setup/Licenses/License";
import StoreRequest from "../../stories/_client/Stores/StoreRequest";
import DevelopmentRequestController from "../../stories/_ticket/DevelopmentRequests/DevelopmentRequestController";
import DevelopmentRequest from "../../stories/_ticket/DevelopmentRequests/DevelopmentRequest";

const PresentForm = props => {
    const { objectType, objectSubType, datas, parentDatas, title, previousLink, successLink, callbackClose, callbackSuccess } = props;
    const { setEvent } = useContext(AppContext);
    const [ loading, setLoading ] = useState(true);
    const [ object, setObject ] = useState(null);
    const [ values, setValues ] = useState(null);
    const [ rows, setRows ] = useState([]);
    const [ stateSubmit, setStateSubmit ] = useState(true);
    const [ saving, setSaving ] = useState(false);
    const [ loadingFileContract, setLoadingFileContract ] = useState(false);
    const navigate = useNavigate();

    const buildController = () => {
        switch (objectType) {
			case "createCompanyGroup":
				return new CompanyController();
			case "updateStore":
				return new StoreController();
			case "developmentRequest":
				return new DevelopmentRequestController();
            case "client":
            case "assignUser":
                return new StoreController();
            case "newLegalData":
            case "updateLegalData":
                return new LegalDataController();
            case "newContact":
            case "updateContact":
                return new ContactController();
            case "newAddress":
            case "updateAddress":
                return new AddressController();
            case "addLicense":
            case "updateLicense":
                return new LicenseController();
            case "addAccount":
            case "addAccountController":
            case "addAccountContact":
                return new AccountController();
            case "newContract":
            case "updateContract":
            case "fileContract":
            case "terminateContract":
                return new ContractController();
            default:
                return null;
        }
    }
    const initObject = () => {
        switch (objectType) {
			case "createCompanyGroup":
				setObject(datas.company);
				break;
			case "updateStore":
				setObject(datas.store);
				break;
			case "developmentRequest":
				switch (objectSubType) {
					case "new":
						setObject(new DevelopmentRequest());
						break;
					default:
						setObject(datas.developmentRequest);
						break;
				}

				break;
            case "client":
				switch (objectSubType) {
					case "request":
						setObject(new StoreRequest());
						break;
					default:
						setObject(new Store());
						break;
				}

                break;
            case "assignUser":
                setObject(parentDatas.store);
                break;
            case "newLegalData":
                setObject(new LegalData());
                break;
            case "updateLegalData":
                setObject(datas.legalDatas);
                break;
            case "newContact":
                setObject(new Contact());
                break;
            case "updateContact":
                setObject(datas.contact);
                break;
            case "newAddress":
                setObject(new Address());
                break;
            case "updateAddress":
                setObject(datas.address);
                break;
            case "addLicense":
                setObject(new License());
                break;
            case "updateLicense":
                setObject(datas.license);
                break;
            case "addAccount":
            case "addAccountController":
            case "addAccountContact":
                setObject(new Account());
                break;
            case "newContract":
                setObject(new Contract());
                break;
            case "updateContract":
            case "fileContract":
            case "terminateContract":
                setObject(datas.contract);
                break;
            default:
                setEvent({
					type: "error",
					text: "Type d'objet inconnu"
				});
                setLoading(false);
                break;
        }
    }
    const initValues = () => {
        const controller = buildController();

        switch (objectType) {
			case "createCompanyGroup":
				controller.setFormValues(object, setValues, false);
				break;
			case "updateStore":
				controller.setFormValues(object, setValues, false, datas.store);
				break;
			case "developmentRequest":
				switch (objectSubType) {
					case "new":
						controller.setFormValues(object, setValues, true);
						break;
					default:
						controller.setFormValues(object, setValues, false);
						break;
				}
				controller.setFormValues(object, setValues);
				break;
            case "assignUser":
                controller.setFormAssignUserValues(object, setValues);
                break;
            case "addLicense":
                controller.setFormValues(object, setValues, true, datas);
                break;
            case "updateLicense":
                controller.setFormValues(object, setValues, false, datas);
                break;
            case "addAccountController":
                controller.setFormControllerValues(setValues);
                break;
            case "addAccountContact":
                controller.setFormFromContactValues(object, setValues, datas);
                break;
            case "updateContact":
            case "updateAddress":
            case "updateContract":
            case "updateLegalData":
                controller.setFormValues(object, setValues, false, datas);
                break;
            case "fileContract":
                controller.setFileContractValues(object, setValues);
                break;
            case "terminateContract":
                controller.setTerminateContractValues(object, setValues);
                break;
			case "client":
				switch (objectSubType) {
					case "request":
						controller.setFormRequestValues(object, setValues, true, datas);
						break;
					default:
						controller.setFormValues(object, setValues, true, datas);
						break;
				}
				break;
            default:
                controller.setFormValues(object, setValues, true, datas);
                break;
        }
    }
    const initDatas = () => {
        const controller = buildController();

        switch (objectType) {
			case "createCompanyGroup":
				controller.setFormRows(setRows);
				break;
			case "updateStore":
				controller.setFormRows(setRows, false, datas.store);
				break;
			case "developmentRequest":
				switch (objectSubType) {
					case "new":
						controller.setFormRows(setRows, true);
						break;
					default:
						controller.setFormRows(setRows, false);
						break;
				}
				break;
            case "assignUser":
                controller.setFormAssignUserRows(setRows, datas);
                break;
            case "addLicense":
                controller.setFormRows(setRows, true, datas);
                break;
            case "updateLicense":
                controller.setFormRows(setRows, false, datas);
                break;
            case "addAccountController":
                controller.setFormControllerRows(setRows);
                break;
            case "addAccountContact":
                controller.setFormFromContactRows(setRows, datas);
                break;
            case "updateContact":
            case "updateAddress":
            case "updateContract":
                controller.setFormRows(setRows, false, datas);
                break;
            case "fileContract":
                controller.setFileContractFormRows(setRows);
                break;
            case "terminateContract":
                controller.setTerminateContractFormRows(setRows);
                break;
			case "client":
				switch (objectSubType) {
					case "request":
						controller.setFormRequestRows(setRows, true, datas);
						break;
					default:
						controller.setFormRows(setRows, true, datas);
						break;
				}
				break;
            default:
                controller.setFormRows(setRows, true, datas);
                break;
        }
    }
	const updateBottomLeftInfos = () => {
		switch (objectType) {
			case "newContract":
			case "updateContract":
				let amounts = ContractController.calculateAmount(values.amountExclTax, values.discountType, values.discountValue, datas.states["POS_WINDOWS"]);
				$("#bottomLeftInfos #amount").text(StringTools.number_format(amounts.amount, 2, ",", " "));

				if (amounts.discountAmount > 0) {
					$("#bottomLeftInfos > .secondText").show();
					$("#bottomLeftInfos > .mainText").removeClass("center");
					$("#bottomLeftInfos #discountAmount").text(StringTools.number_format(amounts.discountAmount, 2, ",", " "));

					if (values.discountDuration !== null && values.discountDuration.length > 0 && parseInt(values.discountDuration) > 0) {
						$("#monthText").show();
						$("#nbMonth").text(parseInt(values.discountDuration));
						$("#bottomLeftInfos #amountUndiscounted").text(StringTools.number_format(amounts.amountOrigin, 2, ",", " "));
					}
					else
						$("#monthText").hide();
				}
				else {
					$("#bottomLeftInfos > .secondText").hide();
					$("#bottomLeftInfos > .mainText").addClass("center");
				}

				break;
			default:
				break;
		}
	}
    const goPrevious = () => {
        if (previousLink !== undefined && previousLink !== null)
            navigate(previousLink, { state: {} });
        else if (callbackClose !== undefined && callbackClose !== null)
            callbackClose();
    }
    const goSuccess = (id = null) => {
        if (successLink !== undefined && successLink !== null) {
			let link = id !== null ? successLink.replace(":id", id) : successLink;
			navigate(link, { state: { refresh: true } });
		}
        else if (callbackSuccess !== undefined && callbackSuccess !== null)
            callbackSuccess();
    }
    const submit = () => {
        if (!stateSubmit || saving)
            return;

        setSaving(true);

        const controller = buildController();
        const datasToSend = getDatas(controller);

        if (datasToSend.length === 0) {
            setSaving(false);
            return;
        }

		if (!controller.okToSend(datasToSend, setEvent)) {
			setSaving(false);
			return;
		}

        controller._callback = resultSubmit;

        send(controller, datasToSend);
    }
    const getDatas = controller => {
        switch (objectType) {
			case "createCompanyGroup":
				return controller.returnPutDatas(values);
			case "updateStore":
				return controller.returnPutDatas(values);
            case "assignUser":
                return controller.returnPostAssignUserDatas(values);
            case "client":
				switch (objectSubType) {
					case "request":
						return controller.returnPostRequestDatas(values);
					default:
						return controller.returnPostDatas(values);
				}
            case "newLegalData":
            case "newContact":
            case "newAddress":
            case "addAccount":
            case "newContract":
            case "addLicense":
                return controller.returnPostDatas(values);
            case "developmentRequest":
				switch (objectSubType) {
					case "new":
						return controller.returnPostDatas(values);
					default:
						return controller.returnPutDatas(values);
				}
            case "addAccountController":
                return controller.returnPostControllerDatas(values);
            case "addAccountContact":
                return controller.returnPostFromContactDatas(values);
            case "updateLicense":
            case "updateContact":
            case "updateAddress":
            case "updateContract":
            case "updateLegalData":
                return controller.returnPutDatas(values);
            case "fileContract":
                return controller.returnFileContractDatas(values);
            case "terminateContract":
                return controller.returnTerminateContractDatas(values);
            default:
                return {};
        }
    }
    const send = (controller, datasToSend) => {
        switch (objectType) {
			case "createCompanyGroup":
				controller.put(datas.company, datasToSend);
				break;
			case "updateStore":
				controller.put(datas.store, datasToSend);
				break;
			case "developmentRequest":
				switch (objectSubType) {
					case "new":
						controller.post(datasToSend);
						break;
					default:
						controller.put(datas.developmentRequest, datasToSend);
						break;
				}

				break;
            case "client":
				switch (objectSubType) {
					case "request":
						controller.request(datasToSend);
						break;
					default:
						controller.post(datasToSend);
						break;
				}

                break;
            case "assignUser":
                controller.put(datas.store, datasToSend);
                break;
            case "newLegalData":
            case "newContact":
            case "newAddress":
                controller.post(datas.store, datasToSend);
                break;
            case "addAccount":
                controller.addAccount(datas.store.setup, datasToSend);
                break;
            case "addAccountController":
                controller.registerControllerAccount(datas.store.setup, datasToSend);
                break;
            case "addAccountContact":
                let datasRegisterAccounts = {
                    contacts: [datasToSend.contact_id],
                    rule: datasToSend.rule
                }

                if (datasToSend.companyRule !== undefined && datasToSend.companyRule !== null)
                    datasRegisterAccounts.companyRule = datasToSend.companyRule;

                controller.registerAccounts(datas.store.setup, datasRegisterAccounts);
                break;
            case "addLicense":
                controller.post(datas.store.setup.id, datasToSend);
                break;
            case "updateLicense":
                controller.put(datas.license, datasToSend);
                break;
            case "updateContact":
            case "updateAddress":
            case "updateLegalData":
                controller.put(datas.store, object, datasToSend);
                break;
            case "newContract":
                controller.post(datas.store.id, datasToSend.license_id, datasToSend);
                break;
            case "updateContract":
                controller.put(object, datasToSend);
                break;
            case "terminateContract":
        		const user = JSON.parse(localStorage.getItem("user"));
				datasToSend.terminated_by = user.id;
                controller.put(object, datasToSend);
                break;
            case "fileContract":
                controller.postFile(object, datasToSend);
                break;
            default:
                break;
        }
    }
    const resultSubmit = (response, error, status) => {
        setSaving(false);

        switch (objectType) {
			case "createCompanyGroup":
				switch (status) {
					case 204:
						goSuccess();
						break;
					default:
						setEvent({
							type: "error",
							text: "Une erreur s'est produite lors de la création du groupe"
						});
						break;
				}

				break;
			case "updateStore":
				switch (status) {
					case 200:
						goSuccess();
						break;
					default:
						setEvent({
							type: "error",
							text: "Une erreur s'est produite lors de la création du groupe"
						});
						break;
				}

				break;
            case "developmentRequest":
				switch (objectSubType) {
					case "new":
						switch (status) {
							case 204:
								goSuccess();
								break;
							default:
								setEvent({
									type: "error",
									text: "Une erreur s'est produite lors de la création de la demande d'évolution"
								});
								break;
						}

						break;
					default:
						switch (status) {
							case 201:
								goSuccess(response.data.id);
								break;
							default:
								setEvent({
									type: "error",
									text: "Une erreur s'est produite lors de la mise à jour de la demande d'évolution"
								});
								break;
						}

						break;
				}

                break;
            case "client":
				switch (objectSubType) {
					case "request":
						switch (status) {
							case 204:
								setEvent({
									type: "valid",
									text: "La requête de création à bien été transmise"
								});
								goSuccess();
								break;
							default:
								setEvent({
									type: "error",
									text: "Une erreur s'est produite lors de l'envoi de la demande de création du client"
								});
								break;
						}

						break;
					default:
						switch (status) {
							case 201:
								goSuccess(response.data.id);
								break;
							default:
								setEvent({
									type: "error",
									text: "Une erreur s'est produite lors de la création du client"
								});
								break;
						}

						break;
				}

                break;
            case "assignUser":
                switch (status) {
                    case 200:
                        goSuccess();
                        break;
                    default:
                        setEvent({
							type: "error",
							text: "Une erreur s'est produite lors de l'enregistrement de l'utilisateur [" + status + "]"
						});
                        break;
                }

                break;
            case "newLegalData":
                switch (status) {
                    case 201:
                        goSuccess();
                        break;
                    default:
                        setEvent({
							type: "error",
							text: "Une erreur s'est produite lors de l'enregistrement des données légales"
						});
                        break;
                }

                break;
            case "newContact":
                switch (status) {
                    case 201:
                        goSuccess();
                        break;
                    default:
                        setEvent({
							type: "error",
							text: "Une erreur s'est produite lors de l'enregistrement du contact"
						});
                        break;
                }

                break;
            case "newAddress":
                switch (status) {
                    case 204:
                        goSuccess();
                        break;
                    default:
                        setEvent({
							type: "error",
							text: "Une erreur s'est produite lors de l'enregistrement de l'adresse"
						});
                        break;
                }

                break;
            case "addAccount":
                switch (status) {
                    case 204:
                        goSuccess();
                        break;
                    default:
                        setEvent({
							type: "error",
							text: "Une erreur s'est produite lors de la création du compte BO"
						});
                        break;
                }

                break;
            case "addAccountController":
                switch (status) {
                    case 204:
                        goSuccess();
                        break;
                    default:
                        setEvent({
							type: "error",
							text: "Une erreur s'est produite lors de la création du compte contrôleur"
						});
                        break;
                }

                break;
            case "addAccountContact":
                switch (status) {
                    case 204:
                        goSuccess();
                        break;
                    default:
                        setEvent({
							type: "error",
							text: "Une erreur s'est produite lors de l'ajout du compte existant"
						});
                        break;
                }

                break;
            case "addLicense":
                switch (status) {
                    case 201:
                        goSuccess();
                        break;
                    default:
                        setEvent({
							type: "error",
							text: "Une erreur s'est produite lors de la création de la nouvelle licence"
						});
                        break;
                }

                break;
            case "updateLicense":
                switch (status) {
                    case 204:
                        goSuccess();
                        break;
                    default:
                        setEvent({
							type: "error",
							text: "Une erreur s'est produite lors de la modification des informations de la licence"
						});
                        break;
                }

                break;
            case "updateContact":
                switch (status) {
                    case 204:
                        goSuccess();
                        break;
                    default:
                        setEvent({
							type: "error",
							text: "Une erreur s'est produite lors de la modification du contact"
						});
                        break;
                }

                break;
            case "updateAddress":
                switch (status) {
                    case 200:
                        goSuccess();
                        break;
                    default:
                        setEvent({
							type: "error",
							text: "Une erreur s'est produite lors de la modification de l'adresse"
						});
                        break;
                }

                break;
            case "updateLegalData":
                switch (status) {
                    case 204:
                        goSuccess();
                        break;
                    default:
                        setEvent({
							type: "error",
							text: "Une erreur s'est produite lors de la modification de les informations légales"
						});
                        break;
                }

                break;
            case "newContract":
                switch (status) {
                    case 201:
                        goSuccess();
                        break;
                    default:
                        setEvent({
							type: "error",
							text: "Une erreur s'est produite lors de la création du contrat"
						});
                        break;
                }

                break;
            case "updateContract":
                switch (status) {
                    case 204:
                        goSuccess();
                        break;
                    default:
                        setEvent({
							type: "error",
							text: "Une erreur s'est produite lors de la modification du contrat"
						});
                        break;
                }

                break;
            case "fileContract":
                switch (status) {
                    case 204:
                        goSuccess();
                        break;
                    default:
						setLoadingFileContract(false);
                        setEvent({
							type: "error",
							text: "Une erreur s'est produite lors de l'ajout du fichier"
						});
                        break;
                }

                break;
            case "terminateContract":
                switch (status) {
                    case 204:
                        goSuccess();
                        break;
                    default:
                        setEvent({
							type: "error",
							text: "Une erreur s'est produite lors de la résiliation du contrat"
						});
                        break;
                }

                break;
            default:
                break;
        }
    }
    const change = (attribute, returnType, value) => {
		switch (attribute) {
			case "bankName":
				if (["newLegalData","updateLegalData"].includes(objectType)) {
					value = (value === "Choisir une banque" || value === "----------") ? null : value;
				}

				break;
			case "city":
				value = value.replace(" ", "-");
				break;
			default: break;
		}

        FormBuilderV2.handleChange(rows, setValues, attribute, returnType, value);
        checkData(attribute, value);
    }
    const checkData = (attribute, value) => {
        const controller = buildController();
        let result = checkingByType(controller, attribute, value);
        let rowsTmp = rows.slice();
        let index = rowsTmp.findIndex(_ => _.attribute === attribute);

        if (rowsTmp[index] === undefined)
            return;

        if (result === null) {
            rowsTmp[index].checkData = null;
            rowsTmp[index].error = null;
        }
        else {
            rowsTmp[index].checkData = result.result ? "valid" : "wrong";
            rowsTmp[index].error = result.error;

			if (objectType === "fileContract") {
				setLoadingFileContract(true);
			}
        }

        setRows(rowsTmp);
    }
    const checkingByType = (controller, attribute, value) => {
        switch (objectType) {
			case "createCompanyGroup":
			case "updateAddress":
			case "updateStore":
				return controller.checkDataToPut(attribute, value);
            case "assignUser":
                return controller.checkDataToAssignUser(attribute, value);
            case "client":
				switch (objectSubType) {
					case "request":
						return controller.checkDataToPostRequest(attribute, value);
					default:
						return controller.checkDataToPost(attribute, value);
				}
            case "newLegalData":
            case "updateLegalData":
            case "newContact":
            case "newAddress":
            case "updateLicense":
            case "addAccount":
            case "addAccountController":
            case "addAccountContact":
            case "newContract":
            case "updateContract":
            case "fileContract":
            case "terminateContract":
                return controller.checkDataToPost(attribute, value);
            case "developmentRequest":
				switch (objectSubType) {
					case "new":
						return controller.checkDataToPost(attribute, value);
					default:
						return controller.checkDataToPut(attribute, value);
				}
            default:
                return null;
        }
    }
    const defineHandleSearch = row => {
        switch (row.attribute) {
            case "company_name":
                switch (objectType) {
                    case "client":
                        return searchCompany;
                    default:
                        return null;
                }
            case "lastname":
                switch (objectType) {
                    case "newContact":
                        return searchContact;
                    default:
                        return null;
                }
            case "email":
                switch (objectType) {
                    case "addAccountContact":
                        return searchContact;
                    default:
                        return null;
                }
            case "tags":
                switch (objectType) {
                    case "newContact":
                        return searchTag;
                    default:
                        return null;
                }
            default:
                return null;
        }
    }
    const defineHandleSearchColumnName = row => {
        switch (row.attribute) {
            case "company_name":
                return "name";
            case "email":
                switch (objectType) {
                    case "addAccountContact":
                        return "email";
                    default:
                        return null;
                }
            default:
                return null;
        }
    }
    const defineHandleClickOnSearch = row => {
        switch (row.attribute) {
            case "company_name":
                switch (objectType) {
                    case "client":
                        return clickOnCompany;
                    default:
                        return null;
                }
            case "lastname":
                switch (objectType) {
                    case "newContact":
                        return clickOnContact;
                    default:
                        return null;
                }
            case "email":
                switch (objectType) {
                    case "addAccountContact":
                        return clickOnContactAccount;
                    default:
                        return null;
                }
            case "tags":
                switch (objectType) {
                    case "newContact":
                        return clickOnTag;
                    default:
                        return null;
                }
            default:
                return null;
        }
    }
    const buildRows = () => {
        if (loading)
            return <LoaderCircle display="loader logWaitForm" hide="" strokeWidth="8" stroke="#008C4F" />;

        let rowsToDisplay = rows.filter(_ => _.hidden === undefined || !_.hidden);

        return <>
            {
                (title !== undefined && title !== null)
                && <p className={"title"}>{ title }</p>
            }
			{
				loadingFileContract
                	? <LoaderCircle display="loader loadingFileForm" strokeWidth={10} />
					: <div className={"scroller" + ((title !== undefined && title !== null) ? " withTitle" : "")}>
						<div className={"shadowTop"} />
						<div className={"shadowBottom"} />
						<div className={"containerInputField"}>
						{
							rowsToDisplay.map((row, index) => (
								<div key={index} className={ "inputField" + (row.classnameWrapper !== undefined && row.classnameWrapper !== null ? " " + row.classnameWrapper : "") }>
									{
										(row.label !== undefined && row.label !== null && row.label.length > 0)
										&& <label className={ row.classnameLabel + (!row.needed ? " optional" : "") } htmlFor={ row.attribute }>{ row.label }</label>
									}
									<div className={"field" + (row.checkData !== null ? " " + row.checkData : "")}>
										{
											FormBuilderV2.buildInputByType(
												row,
												values,
												{
													handleChange: change,
													handleSubmit: submit,
													handleSearch: defineHandleSearch(row),
													handleSearchColumnName: defineHandleSearchColumnName(row),
													handleClickOnSearch: defineHandleClickOnSearch(row)
												},
												index === 0
											)
										}
									</div>
									{
										(row.additional !== undefined && row.additional !== null)
										&& <p className={"additional"}>{row.additional}</p>
									}
									{
										(row.error !== undefined && row.error !== null)
										&& <p className={"errorField"}>{row.error}</p>
									}
								</div>
							))
						}
						</div>
					</div>
			}
        </>;
    }
    const rowsRefreshed = () => {
        if (rows.length === 0)
            return;

        if (loading)
            setLoading(false);

        checkSubmitState();
    }
    const checkSubmitState = () => {
        const controller = buildController();
        setStateSubmit(controller.hasValidMinimumDatas(values, objectType, objectSubType));
    }

    const searchCompany = (input, callback) => {
        const controller = new CompanyController();
        controller._callback = callback;
        controller.index(input, true, 20);
    }
    const clickOnCompany = data => {
        change("company_id", "int", data.id);
        change("company_name", "string", data.text);
    }
    const searchContact = (input, callback) => {
        const controller = new ContactController();
        controller._callback = callback;
        controller.index(input, false, true, 20);
    }
    const clickOnContact = data => {
        change("contact_id", "int", data.id);
        change("lastname", "string", data.text);
    }
    const clickOnContactAccount = data => {
        change("contact_id", "int", data.id);
        change("email", "string", data.text);
    }
    const searchTag = (input, callback) => {
        const controller = new TagController();
        controller._callback = callback;
        controller.index(input, true, 20);
    }
    const clickOnTag = data => {
        change("contact_id", "int", data.id);
        change("lastname", "string", data.text);
    }

    useEffect(() => {
        initObject()
    }, []);
    useEffect(() => {
        if (object !== null)
            initValues()
    }, [object]);
    useEffect(() => {
        if (values !== null && rows.length === 0)
            initDatas();

		if (values !== null)
			updateBottomLeftInfos();
    }, [values]);
    useEffect(() => {
        rowsRefreshed();
    }, [rows]);
    useEffect(() => {
		if (loadingFileContract && stateSubmit)
        	submit();
    }, [loadingFileContract, stateSubmit]);

    return (
        <div className="form padding">
            {
				buildRows()
            }
            <div className={"containerButtons"}>
				{
					["newContract", "updateContract"].includes(objectType)
					&& <div id={"bottomLeftInfos"} className={"bottomLeftInfos"}>
						<p className={"mainText"}>Montant prélevé : <span id={"amount"}>0,00</span> €</p>
						<p className={"secondText"}>Remise de <span id={"discountAmount"}>0,00</span> € <span id={"monthText"}>pendant <span id={"nbMonth"}>3</span> mois, puis <span id={"amountUndiscounted"}>0,00</span> €</span></p>
					</div>
				}
                <button className={"button cancel"} onClick={goPrevious}>Fermer</button>
				{
					!["fileContract"].includes(objectType)
					&& <button className={"button submit"} disabled={!stateSubmit} onClick={submit}>
						{
							saving
								? <>
									<p className={"text"}>Enregistrement...</p>
									<LoaderCircle display="loader" strokeWidth="8" stroke="#FFFFFF" />
								</>
								: <p className={"text"}>Enregistrer</p>
						}
					</button>
				}
            </div>
        </div>
    )
}

export default PresentForm;
